module.exports = __webpack_public_path__ + "static/img/group-12@3x.32d9fee3.png";